module.exports = __webpack_public_path__ + "static/media/app-bar-account.467debc0.svg";